export enum OptionValueType {
  String = 0,
  Number,
  Boolean,
  StringArray,
  NumberArray
}
